module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-register-stevedore/master-register-stevedore.component.scss
// module id = ./src/app/master/master-register-stevedore/master-register-stevedore.component.scss
// module chunks = main